export default __webpack_public_path__ + "static/media/take-screenshot.596e0264.png";